/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { FormControl, HFlow, Radio, Switch } from 'bold-ui'
import theme from 'config/theme'

import { OdontogramaViewMode } from '../OdontogramaField'
import {
  PeriodoOdontogramaSelect,
  PeriodoOdontogramaSelectModel,
} from './PeriodoOdontogramaSelect/PeriodoOdontogramaSelect'

export interface OdontogramaInputsProps {
  prontuarioId: ID
  viewMode: OdontogramaViewMode
  showDeciduos?: boolean
  toggleShowDeciduos(): void
  toggleViewMode(viewMode: string): void
  onChangePeriodo(item: PeriodoOdontogramaSelectModel): void
}

export function OdontogramaInputs(props: OdontogramaInputsProps) {
  const { prontuarioId, viewMode, showDeciduos, toggleViewMode, toggleShowDeciduos, onChangePeriodo } = props

  const viewModeInputsStyles = css`
    margin-top: 0.5rem;
    margin-left: -0.25rem;
    ${theme.breakpoints.down('lg')} {
      grid-gap: 0.25rem;
    }
  `

  return (
    <HFlow
      style={css`
        padding: 0.5rem;
        border: 1px solid ${theme.pallete.divider};
      `}
    >
      <PeriodoOdontogramaSelect prontuarioId={prontuarioId} onChange={onChangePeriodo} />

      <FormControl
        label={
          <span
            css={css`
              white-space: nowrap;
            `}
          >
            Visualizar odontograma por
          </span>
        }
      >
        <HFlow hSpacing={0.75} style={viewModeInputsStyles}>
          <Radio
            label='Dentes'
            value='dentes'
            checked={viewMode === 'dentes'}
            onChange={(e) => toggleViewMode(e.currentTarget.value)}
          />
          <Radio
            label='Sextantes'
            value='sextantes'
            checked={viewMode === 'sextantes'}
            onChange={(e) => toggleViewMode(e.currentTarget.value)}
          />
          <Radio
            label='Arcadas'
            value='arcadas'
            checked={viewMode === 'arcadas'}
            onChange={(e) => toggleViewMode(e.currentTarget.value)}
          />
          <Radio
            label='Outros'
            value='outros'
            checked={viewMode === 'outros'}
            onChange={(e) => toggleViewMode(e.currentTarget.value)}
          />
        </HFlow>
      </FormControl>

      <FormControl
        label={
          <span
            css={css`
              white-space: nowrap;
            `}
          >
            Mostrar dentes decíduos
          </span>
        }
      >
        <Switch
          label={showDeciduos ? 'Sim' : 'Não'}
          onChange={toggleShowDeciduos}
          style={{ marginTop: '0.25rem' }}
          disabled={viewMode !== 'dentes'}
          checked={showDeciduos}
        />
      </FormControl>
    </HFlow>
  )
}
